<template>
    <main>
        <div v-if="dataPageInfos.urlPictureHeader" class="bg-header-page" :style="{ 'background-image': 'url('+ dataPageInfos.urlPictureHeader + ')' }" style="background-size:cover !important; background-position:center !important; background-repeat:no-repeat !important; "></div>
        <div v-else-if="dataPage.route !== 'accueil'" class="bg-header-page" style="background-image:url('./photos/background-header-page.jpg'); background-size:cover !important; background-position:bottom !important; bakcground-repeat:no-repeat !important;"></div>
    
        <div class="container" :class="(dataPage.route == 'accueil' ? '' : 'header-page')">
            <div class="row">
                <div class="col-sm-12 col-md-5 col-lg-4 col-brand" :class="(dataPage.route == 'accueil' ? '' : 'not')">
                    <!-- LOGO -->
                    <div id="logo" :class="(dataPage.route == 'accueil' ? '' : 'logo-after')"> 
                        <router-link tag="a"  to="accueil" class="d-block">
                          <img src="@/../public/elements/logo-veroniquelesourd.png" alt="logo">
                        </router-link>
                    </div>
                    <!-- PHOTO DE MME LESOURD -->
                    <div id="photo" v-if="dataPage.route == 'accueil'">
                        <img src="@/../public/elements/photo.png" alt="photo">
                    </div>
                </div>
                <!-- TEXTE SUR CAROUSEL -->
                <div id="text-carousel" class="c-w col-sm-12 col-md-7 col-lg-8" :class="(dataPage.route == 'accueil' ? '' : 'd-none d-md-block')">
                    <p>Le plus grand secret pour le bonheur,<br> c'est d'être bien avec soi.</p>
                    <p>Bernard Fontenelle</p>
                </div>
            </div>
        </div>

        <div v-if="dataPage.route == 'accueil'">
          <!-- ELEMENTS SUR CAROUSEL HAUT DE PAGE -->
          <div class="presentation">
            <b-carousel
              id="carouselExampleControls"
              class="carousel slide z-depth-1-half" 
              :interval="6000"
              background="#ffffff"
              img-width="1024"
              img-height="480"
              fade
              no-hover-pause
            >
              <b-carousel-slide v-if="dataPage.customizableVar[0].value" :img-src="dataPage.customizableVar[0].value"></b-carousel-slide>
              <b-carousel-slide v-if="dataPage.customizableVar[1].value" :img-src="dataPage.customizableVar[1].value"></b-carousel-slide>
              <b-carousel-slide v-if="dataPage.customizableVar[2].value" :img-src="dataPage.customizableVar[2].value"></b-carousel-slide>
            </b-carousel>
          </div>
          <!-- CONTENU 1 AVEC FOND BLEU -->
          <div class="contenu1">
              <div class="container">
                  <div class="d-block d-md-none" style="height:70px"></div>
                  <div class="row">
                      <div class="offset-md-5 offset-lg-4 offset-xl-4 col">
                          <p class="font-30px c-w text-justify">Bonjour je suis Véronique LESOURD, <span class="font-30px c-v">practicien en
                                  hypnose</span>, <span class="font-30px c-v">coach</span> et
                              <span class="font-30px c-v">magnétiseur</span> à Rouen.</p>
                          <p class="font-20px c-w text-justify">Je suis votre allier pour parvenir à la réussite de vos objectifs, ou pour
                              vous accompagner dans vos maux et souffrances à l'aide de l'hypnose thérapeutique, du coaching
                              et/ou du magnétisme.</p>
                      </div>
                  </div>
              </div>
              <div class="container d-flex flex-lg-row flex-column">
                  <div class="row">
                      <!-- MENU DE GAUCHE -->
                      <div class="col-sm-12 col-md-5 col-lg-4 col-xl-4  mb-4">
                          <ul class="p-0">
                              <li class="list-unstyled text-end"><a class="font-20px c-w text-decoration-none"
                                      href='#'>Magnétisme</a></li>
                              <li class="list-unstyled text-end"><a class="font-20px c-w text-decoration-none"
                                      href='#'>Hypnose</a></li>
                              <li class="list-unstyled text-end"><a class="font-20px c-w text-decoration-none"
                                      href='#'>Coaching et PNL</a></li>
                              <li class="list-unstyled text-end"><a class="font-20px c-w text-decoration-none"
                                      href='#'>Hypno-Coaching en entreprise</a></li>
                              <li class="list-unstyled text-end"><a class="font-20px c-w text-decoration-none"
                                      href='#'>Massage bien-être</a></li>
                          </ul>
                          <!-- BOUTON PRENDRE RDV -->
                          <router-link to="contact" tag="a" class="c-b text-decoration-none d-flex justify-content-center mb-4" role="button">
                              <div class="pr-rdv">
                                  <p>Prendre RDV maintenant</p>
                                  <div class="click">
                                      <img src="@/../public/elements/cursor.svg" alt="">
                                  </div>
                              </div>
                          </router-link>
                      </div>

                      <div class="col-sm-12 col-md-7 col-lg-8 col-xl-8  d-flex flex-column align-items-end d-flex flex-column align-items-end">
                          <p class="font-20px c-g text-justify">Que votre objectif soit d'arrêter de fumer, de perdre du poids, de soulager
                              vos douleurs, de vos maux tels que l'arthrose, les rhumatismes, le stress, faire un deuil,
                              gagner en confiance en soi, améliorer votre vie... et bien d'autres objectifs que vous souhaitez
                              atteindre, l'hypnose et/ou le magnétisme, sont disciplines toutes deux utilisées et reconnues
                              aussi bien en cabinet que dans les hôpitaux, au cours d'opération, dans le cadre de la gestion
                              de la douleur et aussi pour couper le feu.

                          </p>

                          <p class="font-20px c-g text-justify">Proche de Rouen, je vous reçois en Hypnose ou en magnétisme, pour des
                              séances dont le déroulement commencent par une phase d'accueil, avec une écoute attentive et
                              bienveillante, le but étant de vous accompagner, de répondre à vos besoins et attentes avec
                              douceur dans le respect de votre personnalité.
                          </p>
                          <!-- BOUTON EN SAVOIR PLUS -->
                          <router-link tag="a" to="presentation" class=" c-w text-decoration-none">
                              <div class="en-savoir">
                                  <p class="font-20px mt-5">En savoir plus</p>
                                  <img src="@/../public/elements/chevron.svg" alt="">
                              </div>
                          </router-link>
                      </div>
                  </div>

              </div>
          </div>
          <!-- CONTENU 2 AVEC FOND VERT -->
          <div class="contenu2">
              <div class="container">
                  <div class="row">

                      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 texte" style="background:url('elements/background-element-magnetisme.jpg') no-repeat top center; background-size:80%; background-position: center;  z-index: -1;">
                          <h1 class="titre c-w">Mon Cabinet</h1>
                          <h2 class="c-w font-25px">Pour un accompagnement en physique</h2>
                          <p class="font-20px mb-5 c-g">Situé au coeur de la Métropole Rouennaise, je vous accueille dans mon
                              cabinet aménagé pour vous plonger dans un moment de détente, une situation idéale pour capter
                              les bienfaits de mon accompagnement.
                          </p>
                          <p class="font-30px c-w text-center"><span class="font-15px">(à proximité de la Place Saint Paul de Rouen)</span><br>
                          270A Route de Paris<br>76920 Amfreville-la-Mi-Voie</p>
                          <p class="font-20px c-g text-center">Facile d'accès, mon cabinet met à votre disposition une place
                              de stationnement gratuite.</p>
                          <h1 class="titre c-w">Séance en visio</h1>
                          <h2 class="c-w font-25px">Pour un accompagnement facile et à distance.</h2>
                          <p class="font-20px c-g">Certaines prestations peuvent être effectuées à distance par
                              visio-conférence ou téléphone. Je vous propose les outils tels que :</p>
                          <div class="logo w-100 flex-row d-flex justify-content-around mx-3 mb-5">
                              <img class="zoom" src="@/../public/elements/zoom.png" alt="">
                              <img class="skype" src="@/../public/elements/skype.png" alt="">
                          </div>
                      </div>
      
                      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-center align-items-center">
                          <!-- CAROUSEL -->
                          <div id="carouselExampleIndicators2" class="carousel slide" data-ride="carousel" style="    width: 100%;">
                              <ol class="carousel-indicators">
                                  <li data-target="#carouselExampleIndicators2" data-slide-to="0" class="active"></li>
                                  <li data-target="#carouselExampleIndicators2" data-slide-to="1"></li>
                                  <li data-target="#carouselExampleIndicators2" data-slide-to="2"></li>
                                  <li data-target="#carouselExampleIndicators2" data-slide-to="3"></li>
                                  <li data-target="#carouselExampleIndicators2" data-slide-to="4"></li>
                              </ol>
                              <div class="carousel-inner">
                                  <div class="carousel-item active">
                                      <img src="@/../public/photos/photo-veroniquelesourd-accueil-01.jpeg" class="d-block w-100" alt="...">
                                  </div>
                                  <div class="carousel-item">
                                      <img src="@/../public/photos/photo-veroniquelesourd-accueil-02.jpeg" class="d-block w-100" alt="...">
                                  </div>
                                  <div class="carousel-item">
                                      <img src="@/../public/photos/photo-veroniquelesourd-accueil-03.jpeg" class="d-block w-100" alt="...">
                                  </div>
                                  <div class="carousel-item">
                                      <img src="@/../public/photos/photo-veroniquelesourd-accueil-04.jpeg" class="d-block w-100" alt="...">
                                  </div>
                                  <div class="carousel-item">
                                      <img src="@/../public/photos/photo-veroniquelesourd-accueil-05.jpeg" class="d-block w-100" alt="...">
                                  </div>
                              </div>
                              <a class="carousel-control-prev" href="#carouselExampleIndicators2" role="button"
                                  data-slide="prev">
                                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                  <span class="sr-only">Previous</span>
                              </a>
                              <a class="carousel-control-next" href="#carouselExampleIndicators2" role="button"
                                  data-slide="next">
                                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                  <span class="sr-only">Next</span>
                              </a>
                          </div>
      
      
      
                      </div>
                  </div>
              </div>

          </div>
          <!-- CONTENU 3 AVEC FOND VIOLET -->
          <div class="contenu3 esp-violet">
              <div class="container">
                  <div class="row flex justify-content-center">
                      <h1 class="titre c-w">Témoignages clients</h1>
                  </div>
              </div>
              <div class="carousel-reviews broun-block">
                  <div class="container">
                      <div class="row">
                          <div id="carousel-reviews" class="carousel slide" data-ride="carousel">
                          
                              <div class="carousel-inner">
                                  <div class="item active row">
                                      <div class="col-md-4 col-sm-6">
                                          <div class="block-text rel zmin">
                                              <p>La légère appréhension précédant la première séance d'hypnose s'est vite dissipée grâce à l'accueil chaleureux et à la simplicité de Lesourd. Lesourd Véronique est une hypnothérapeute magnétiseur dynamique et avec un bon contact. Je vous recommanderai !</p>
                                              <ins class="ab zmin sprite sprite-i-triangle block"></ins>
                                          </div>
                                          <div class="person-text rel">
                                              <a title="" href="#">Florentin C</a>
                                          </div>
                                      </div>
                                      <div class="col-md-4 col-sm-6 hidden-xs">
                                          <div class="block-text rel zmin">
                                              <p>Entre deux compétitions j'en profite pour vous remercier ! Première séance de méditation avec Lesourd hier. Elle a réussi à soulager mes souffrances d'infertilité. Vous méritez votre réputation ! "  </p>
                                              <ins class="ab zmin sprite sprite-i-triangle block"></ins>
                                          </div>
                                          <div class="person-text rel">
                                              <a title="" href="#">A. Jourdain</a>
                                          </div>
                                      </div>
                                      <div class="col-md-4 col-sm-6 hidden-sm hidden-xs">
                                          <div class="block-text rel zmin">
                                              <p>J'ai eu une très bonne expérience d'Hypnose avec Véronique, elle est vraiment très forte et elle m'a permis d'avancer. Encore merci......;-)</p>
                                              <ins class="ab zmin sprite sprite-i-triangle block"></ins>
                                          </div>
                                          <div class="person-text rel">
                                              <a title="" href="#">Corinne Goudemare</a>
                                          </div>
                                      </div>
                                  </div>             
                              </div>
                              <a class="left carousel-control" href="#carousel-reviews" role="button" data-slide="prev">
                                  <span class="glyphicon glyphicon-chevron-left"></span>
                              </a>
                              <a class="right carousel-control" href="#carousel-reviews" role="button" data-slide="next">
                                  <span class="glyphicon glyphicon-chevron-right"></span>
                              </a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <div v-else-if="dataPage.route == 'contact'">
          <div class="contenu1-contact">
            <div class="container">
                <p class="font-30px c-bleu">Pour vos <span class="fw-b font-30px">rendez-vous</span>, je vous reçois <span class="fw-b font-30px">dans mon cabinet</span> et à proximité de
                    Rouen <span class="fw-b font-30px">ou</span> j’effectue une consultation <span class="fw-b font-30px">par visio-conférence</span>.</p>
                <div class="w-100 d-flex flex-column align-items-center justify-content-center mt-5">
                    <p class="font-30px c-bleu text-center">Prenez <span class="font-30px c-v fw-b">rendez-vous</span> dès maintenant et
                        facilement.<br>
                        <i class="font-20px c-bleupt-0 mt-0">En remplissant le formulaire ci-après  ou sur Medoucine en <a class="font-20px" href="https://www.medoucine.com/consultation/amfreville-la-mi-voie/veronique-lesourd/1476" target="new">cliquant ici</a> :</i>
                    </p>
                    <!-- FORMULAIRE -->
                    <div v-if="formContact.send" class="row w-100 d-flex flex-row justify-content-between align-items-center" style="margin-top:60px; margin-bottom:60px">
                      <div class="flex center flex-center mt-4 mb-4 text-center form-send">
                          <feather-icon class="m-0"  icon='CheckCircleIcon' svgClasses='widthCheck'   />
                          <h1 class="mt-2 mb-4 c-v">Merci</h1>
                          <p class="font-20px">    
                              Votre email a été correctément envoyé<br>
                              Nous vous répondrons dans les meilleurs délais
                          </p>
                      </div>
                    </div>
                    <div v-else class="row w-100 d-flex flex-row justify-content-between align-items-start ">
                      <div class="col-md-5 col-12 d-flex flex-column justify-content-start">
                        <div class="row">
                          <div class="col-6">
                            <label class="c-v font-20px" for="lastname">Nom</label>
                            <input :class="errors.has('lastname') ? 'error' : ''" type="text" id="lastname" name="lastname" v-validate="'required'" v-model="formContact.dataForm.lastname" data-vv-validate-on="blur" />
                            <span class="text-danger font-15px text-sm d-block mt-3 text-error" v-show="errors.has('lastname')">{{ errors.first('lastname') }}</span>
                          </div>
                          <div class="col-6">
                            <label class="c-v font-20px" for="firstname">Prénom</label>
                            <input :class="errors.has('firstname') ? 'error' : ''" type="text" id="firstname" name="firstname" v-validate="'required'" v-model="formContact.dataForm.firstname" data-vv-validate-on="blur" />
                            <span class="text-danger font-15px text-sm d-block mt-3 text-error" v-show="errors.has('firstname')">{{ errors.first('firstname') }}</span>
                          </div>
                        </div>
                        <label class="c-v font-20px pt-5" for="email">Adresse E-mail</label>
                        <input :class="errors.has('email') ? 'error' : ''" type="text" id="email" name="email" v-validate="'required'" v-model="formContact.dataForm.email" data-vv-validate-on="blur" />
                        <span class="text-danger font-15px text-sm mt-3 text-error" v-show="errors.has('email')">{{ errors.first('email') }}</span>

                        <label class="c-v font-20px pt-5" for="phone">Téléphone</label>
                        <input :class="errors.has('phone') ? 'error' : ''" type="text" name="phone" v-validate="'required'" v-model="formContact.dataForm.phone" data-vv-validate-on="blur" />
                        <span class="text-danger font-15px text-sm mt-3 text-error" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>

                        <label class="c-v font-20px pt-5" for="date">Date / Heure Souhaitée</label>
                        <input :class="errors.has('date') ? 'error' : ''" type="text" id="date" name="date" v-model="formContact.dataForm.details[0].details[1].value" data-vv-validate-on="blur" />
                        <span class="text-danger font-15px text-sm mt-3 text-error" v-show="errors.has('date')">{{ errors.first('date') }}</span>

                      </div>
                      <div class="col-md-7 col-12 d-flex position-relative flex-column align-items-start justify-content-start ">
                          <label class="c-v font-20px" for="prestations">Quelle prestation rechechez-vous ?</label>
                          <input :class="errors.has('prestations') ? 'error' : ''" type="text" id="prestations" name="prestations"  v-model="formContact.dataForm.details[0].details[0].value" data-vv-validate-on="blur" />
                          <span class="text-danger font-15px text-sm d-block mt-3 text-error" v-show="errors.has('prestations')">{{ errors.first('prestations') }}</span>
                          <!-- <select id="prestations" name="prestations"   v-model="formContact.dataForm.details[0].details[0].value" >
                              <option value="tabac">Accompagnement pour l'arret du tabac</option>
                              <option value="exemple">Exemple de prestations</option>
                              <option value="exemple">Exemple de prestations</option>
                              <option value="exemple">Exemple de prestations</option>
                              <option value="exemple">Exemple de prestations</option>
                              <option value="exemple">Exemple de prestations</option>
                          </select> -->
                          <label class="mt-5 c-v font-20px w-100" for="message">Précisez votre Situation / Votre
                              besoin:</label>
                          <textarea  v-model="formContact.dataForm.details[0].details[2].value" type="text" rows="14" style="height:160px"></textarea>
                          <div class="row mt-4">
                            <div class="col-7">
                              <vue-recaptcha ref="recaptcha" @verify="onVerify" sitekey="6Ldao10aAAAAALdceoWm0r1LUShr-Sm2z7JAPHSj">
                              </vue-recaptcha>
                            </div>
                            <div class="col-5">
                              <p class="c-bleu font-30px mt-5" id="envoyer"  @click.prevent="submitForm">Envoyer</p>
                            </div>
                          </div>
                      </div>
                    </div>

                </div>
            </div>
          </div>

          <div class="contenu2-contact">
              <div class="container">
                <div class="row d-flex flex-row justify-content-around align-items-center text-center">
                  <div class="col-lg-5 col-md-6 col-12">
                    <p class="c-g font-25px mb-0">ou par email :</p>
                    <p class="c-w font-20px pt-0 pb-5">contact@veroniquelesourd.fr</p>
                    <p class="c-g font-25px pt-5">ou par téléphone :</p>
                    <p class="c-w font-40px  mt-0 ">06 50 73 61 18</p>
                  </div>
                  <div class="col-1 d-none d-lg-flex">
                    <img src="@/../public/elements/separateur-gris-vertical.png" style="max-height:220px" />
                  </div>
                  <div class="col-lg-5 col-md-6 col-12">
                    <img src="@/../public/elements/marker-map-gris.png" style="max-height:60px" class="mb-5" />
                    <p class="c-g font-20px">A proximité de la Place Saint Paul de Rouen</p>
                    <p class="c-w font-25px  mt-0 ">270A route de Paris<br>76920 Amfreville-La-Mi-Voie</p>
                  </div>
                </div>
              </div>
          </div>

          <div class="contenu3-contact">
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1294.6571503157047!2d1.1053275393052449!3d49.43363277113326!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e0dfc15627a111%3A0x13e4d7c34e4d64dc!2sV%C3%A9ronique%20LESOURD%20-%20Hypnose!5e0!3m2!1sfr!2sfr!4v1609341941463!5m2!1sfr!2sfr"
                width="100%" height="420" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false"
                tabindex="0"></iframe>
          </div>
        </div>
        <div v-else-if="dataPage.route == 'actualites'">
          <div class="contenu blog">
            <div class="row rowWidget w-100 mb-2" id="esp-seance-1" v-for="(article, index) of  this.$parent.dataIris.articles" :key="index">
              <div class="colonne mb-5 col-md-12">
                <div class="container">
                  <div class="row rowWidget">
                    <div class="colonne mb-5 col-md-6">
                      <div class="item noEditMode">
                        <div class="item-image">
                          <div style="display: flex; width: 100%; justify-content: center;">
                            <img :src="article.urlPictureHeader" alt="" style="width: 100%;">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="colonne mb-5 col-md-6">
                      <div class="item-title">
                        <h1>{{article.title}}</h1>
                      </div>
                      <div class="item noEditMode">
                        <p>{{article.description}}</p>
                        
                        <router-link tag="a" :to="'/blog/'+article.route" class=" c-w text-decoration-none">
                          <div class="en-savoir">
                            <p class="font-20px mt-5">En savoir plus</p>
                            <img src="img/chevron.024b0a27.svg" alt="">
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>

                       
          <div class="contenu">
            <div
              class="item noEditMode"
              v-for="(item, index) in layout"
              :key="index"
            >
              <row-widget
                :class="item.styleClass"
                :style="item.style"
                :id="item.styleId"
                v-if="item.type == 'row'"
                :layout="layout"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                class="mb-2"
              ></row-widget>
              <col-widget
                v-if="item.type == 'col'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></col-widget>
              <text-widget
                v-if="item.type == 'text'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                :themeColors="themeColors"
              ></text-widget>
              <text-area-widget
                v-if="item.type == 'content'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></text-area-widget>
              <image-widget
                v-if="item.type == 'image'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></image-widget>
              <alert-widget
                v-if="item.type == 'alert'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                :color="item.color"
              >
              </alert-widget>
              <button-widget
                v-if="item.type == 'button'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              >
              </button-widget>
              <link-widget
                v-if="item.type == 'link'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              >
              </link-widget>
              <title-widget
                v-if="item.type == 'title'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></title-widget>
              <quote-widget
                v-if="item.type == 'quote'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></quote-widget>
            </div>
          </div>
          
          <div class="contenu-contact" >
            <div class="container d-flex flex-column justify-content-center align-items-center">
                <router-link to="contact" tag="a" class="c-b text-decoration-none" role="button">
                    <div class="pr-rdv">
                        <p>Prendre RDV maintenant</p>
                        <div class="click">
                            <img src="@/../public/elements/cursor.svg" alt="">
                        </div>
                    </div>
                </router-link>
                <p class="font-20px c-w mt-5">ou par téléphone :</p>
                <a href="tel:0650736118" class="font-40px text-decoration-none c-v fontweight-800">06 50 73 61 18</a>
            </div>
          </div>
        </div>

    </main>
    <!--
   
    <div v-if="dataPage.route == 'accueil'" class="accueil">
      <div class="bg-bf">
        <b-carousel
          id="carouselHome"
          :interval="6000"
          background="#154059"
          img-width="1024"
          img-height="480"
          fade
          no-hover-pause
        >
          <div class="d-lg-flex d-none position-absolute" id="logo">
            <img src="@/../public/elements/logo-cbgr-inverse.png" alt="logo" />
          </div>
          <div class="d-flex d-lg-none position-absolute" id="slogan">
            <h1 v-html="dataPage.title"></h1>
          </div>
          <b-carousel-slide img-blank v-if="dataPage.customizableVar[0].value">
            <div
              class="carousel-image"
              :style="{ 'background-image': 'url('+ dataPage.customizableVar[0].value + ')' }"
              style="
                background-position: top;
                background-size: cover;
              "
            ></div>
          </b-carousel-slide>
          <b-carousel-slide img-blank v-if="dataPage.customizableVar[1].value">
            <div
                class="carousel-image"
                :style="{ 'background-image': 'url('+ dataPage.customizableVar[1].value + ')' }"
                style="
                  background-position: top;
                  background-size: cover;
                "
            ></div>
          </b-carousel-slide>
          <b-carousel-slide img-blank v-if="dataPage.customizableVar[2].value">
            <div
                class="carousel-image"
                :style="{ 'background-image': 'url('+ dataPage.customizableVar[2].value + ')' }"
                style="
                  background-position: top;
                  background-size: cover;
                "
            ></div>
          </b-carousel-slide>
          <div id="menu" class="d-none d-lg-block">
            <ul>
              <li
                class="nav-item"
                v-for="(menu, index) of $parent.dataIris.menuHeader.itemsMenu
                  .children"
                :key="index"
              >
                <router-link
                  tag="a"
                  :to="menu.route"
                  class="c-bf bg-w text-uppercase"
                  href="#"
                  >{{ menu.labelMenu }}</router-link
                >
              </li>
            </ul>
          </div>
        </b-carousel>
        <div class="d-block d-lg-none pt-4">
          <div class="col-12 c-w">
            <div
              class="item noEditMode"
              v-for="(item, index) in layout"
              :key="index"
            >
              <row-widget
                v-if="item.type == 'row'"
                :layout="layout"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                class="mb-2"
              ></row-widget>
              <col-widget
                v-if="item.type == 'col'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></col-widget>
              <text-widget
                v-if="item.type == 'text'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                :themeColors="themeColors"
              ></text-widget>
              <text-area-widget
                v-if="item.type == 'content'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></text-area-widget>
              <image-widget
                v-if="item.type == 'image'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></image-widget>
              <alert-widget
                v-if="item.type == 'alert'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                :color="item.color"
              >
              </alert-widget>
              <button-widget
                v-if="item.type == 'button'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              >
              </button-widget>
              <link-widget
                v-if="item.type == 'link'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              >
              </link-widget>
              <title-widget
                v-if="item.type == 'title'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></title-widget>
              <quote-widget
                v-if="item.type == 'quote'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></quote-widget>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="dataPage.route == 'contact'">
      <div id="main-contact">
        <div class="d-flex position-relative" id="titre">
          <h1>CONTACTEZ-NOUS</h1>
        </div>
        <div id="article">
          <div
            
            class="content-contact d-flex flex-column flex-lg-row  justify-content-left align-items-left mt-4 rowWidget"
          >
            <div v-if="formContact.send" class="col-lg-6 col-12" style="margin-top:100px">
              <div class="flex center flex-center mt-4 mb-4 text-white text-center form-send">
                  <feather-icon class="m-0"  icon='CheckCircleIcon' svgClasses='widthCheck'   />
                  <h3 class="mt-2 mb-4">Merci</h3>
                  <p >    
                      Votre email a été correctément envoyé<br>
                      Nous vous répondrons dans les meilleurs délais
                  </p>
              </div>
            </div>
            <div v-else class="col-lg-6 col-12" id="contact">
              <div class="row">
                <div class="fancy-label name col-12 col-lg-6">
                  <input :class="errors.has('firstname') ? 'error' : ''" type="text" id="nom" name="firstname" v-validate="'required|alpha'" v-model="formContact.dataForm.firstname"  data-vv-validate-on="blur" />
                  <label for="nom">Votre Prénom</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('firstname')">{{ errors.first('firstname') }}</span>
                </div>

                <div class="fancy-label name col-12 col-lg-6">
                  <input :class="errors.has('lastname') ? 'error' : ''" type="text" id="prenom" name="lastname" v-validate="'required|alpha'" v-model="formContact.dataForm.lastname"  data-vv-validate-on="blur" />
                  <label for="prenom">Votre Nom</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('lastname')">{{ errors.first('lastname') }}</span>
                </div>

                <div class="fancy-label name col-12 col-lg-6">
                  <input :class="errors.has('phone') ? 'error' : ''" type="text" id="email" name="phone" v-validate="'required'" v-model="formContact.dataForm.phone" data-vv-validate-on="blur" />
                  <label for="email">Votre Téléphone</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
                </div>
                <div class="fancy-label name col-12 col-lg-6">
                  <input :class="errors.has('email') ? 'error' : ''" type="text" id="email" name="email" v-validate="'required'" v-model="formContact.dataForm.email" data-vv-validate-on="blur" />
                  <label for="email">Votre Adresse E-mail</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                </div>
                <hr>
                <div class="fancy-label name col-12">
                  <select id="praticien" name="praticien"  class="form-control" v-model="formContact.dataForm.details[0].details[0].value" >
                      <option value="Tous les praticiens">Tous les praticiens</option>
                      <option value="Dr Clémentine DECRETTE">Dr Clémentine DECRETTE</option>
                      <option value="Dr Thibault GANCEL">Dr Thibault GANCEL</option>
                      <option value="Dr Antoine GODDEFROY">Dr Antoine GODDEFROY</option>
                      <option value="Dr Edouard SOUBRANE">Dr Edouard SOUBRANE</option>
                      <option value="Dr Marie DELAUME">Dr Marie DELAUME</option>
                      <option value="Dr Claire NICOLAS">Dr Claire NICOLAS</option>
                  </select>
                  <label for="praticien">Quel praticien souhaitez-vous joindre ?</label>
                </div>

                <div class="fancy-label name col-12">
                  <select id="objet" name="objet" class="form-control" v-model="formContact.dataForm.details[1].details[0].value">
                      <option value="Une demande de RDV">Une demande de RDV</option>
                      <option value="Une demande administrative">Une demande administrative</option>
                      <option value="Autre">Autre</option>
                  </select>
                  <label for="objet">Quel est l'objet de votre message ?</label>
                </div>

                <div class="fancy-label message name col-12 mb-2">
                  <textarea :class="errors.has('message') ? 'error' : ''"  v-validate="'required'" row="5" type="text" id="message" name="message" v-model="formContact.dataForm.details[1].details[1].value" data-vv-validate-on="blur"></textarea>
                  <label for="message">Votre message</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('message')">{{ errors.first('message') }}</span>
                </div>

                <div class="col-12 col-lg-6">
                    <vue-recaptcha ref="recaptcha" @verify="onVerify" sitekey="6Ldc4TwaAAAAAGQzSYruyBJ-zsoeP89j1uJjdamz">
                    </vue-recaptcha>
                </div>
                <div class="col-12 col-lg-6 mb-4">
                  <button id="button-contact" @click.prevent="submitForm">Envoyer mon message</button>
                </div>
              </div>
            </div>

            <div class="col-lg-6 col-12">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d750.3238715048234!2d1.1149476128527995!3d49.47087923013478!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e0dc4ff83b4c27%3A0x9e77674fb485fd2!2s362%20Rue%20de%20la%20R%C3%A9publique%2C%2076230%20Bois-Guillaume!5e0!3m2!1sfr!2sfr!4v1606487345628!5m2!1sfr!2sfr"
                width="100%"
                height="500"
                frameborder="0"
                allowfullscreen=""
                aria-hidden="false"
                tabindex="0"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
        <div id="main-contenu" class="pb-4">
        <div class="d-flex  position-relative" id="titre" v-if="typePage !== '1'">
            <h1>{{dataPage.title}}</h1>
        </div>

        <div
              class="item noEditMode d-flex flex-column flex-lg-row justify-content-start align-items-center c-w"
              v-for="(item, index) in layout"
              :key="index"
              id="article"
            >
              <row-widget
                v-if="item.type == 'row'"
                :layout="layout"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                class="mb-2"
              ></row-widget>
              <col-widget
                v-if="item.type == 'col'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></col-widget>
              <text-widget
                v-if="item.type == 'text'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                :themeColors="themeColors"
              ></text-widget>
              <text-area-widget
                v-if="item.type == 'content'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></text-area-widget>
              <image-widget
                v-if="item.type == 'image'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></image-widget>
              <alert-widget
                v-if="item.type == 'alert'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                :color="item.color"
              >
              </alert-widget>
              <button-widget
                v-if="item.type == 'button'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              >
              </button-widget>
              <link-widget
                v-if="item.type == 'link'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              >
              </link-widget>
              <title-widget
                v-if="item.type == 'title'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></title-widget>
              <quote-widget
                v-if="item.type == 'quote'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></quote-widget>
            </div>

    </div>
    </div>

    <div v-if="typePage == '1'">
      <div id="main-contact" class="pt-0 pt-0">
        <div class="d-flex position-relative" id="titre">
          <h1>Contacter le Docteur</h1>
        </div>

     

        <div
          id="article"
          class="content-contact d-flex flex-column flex-lg-row  justify-content-left align-items-left mt-4"
        >
          <div v-if="formContact.send" class="content-contact d-flex flex-column flex-lg-row  justify-content-left align-items-start mt-4 rowWidget" style="margin-top:100px; margin-bottom:40px">
            <div class="col-lg-12 col-12 text-white text-center form-send">
                <feather-icon class="m-0"  icon='CheckCircleIcon' svgClasses='widthCheck'   />
                <h3 class="mt-2 mb-4">Merci</h3>
                <p >    
                    Votre email a été correctément envoyé<br>
                    Nous vous répondrons dans les meilleurs délais
                </p>
            </div>
          </div>
          <div v-else class="content-contact d-flex flex-column flex-lg-row justify-content-left align-items-start mt-4 rowWidget" id="contact">
            <div class="col-lg-6 col-12">
              <div class="row">
                <div class="fancy-label name col-12 col-lg-6">
                  <input :class="errors.has('firstname') ? 'error' : ''" type="text" id="nom" name="firstname" v-validate="'required|alpha'" v-model="formContact.dataForm.firstname"  data-vv-validate-on="blur" />
                  <label for="nom">Votre Prénom</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('firstname')">{{ errors.first('firstname') }}</span>
                </div>
                <div class="fancy-label name col-12 col-lg-6">
                  <input :class="errors.has('lastname') ? 'error' : ''" type="text" id="prenom" name="lastname" v-validate="'required|alpha'" v-model="formContact.dataForm.lastname"  data-vv-validate-on="blur" />
                  <label for="prenom">Votre Nom</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('lastname')">{{ errors.first('lastname') }}</span>
                </div>
                <div class="fancy-label name col-12 col-lg-6">
                  <input :class="errors.has('phone') ? 'error' : ''" type="text" id="email" name="phone" v-validate="'required'" v-model="formContact.dataForm.phone" data-vv-validate-on="blur" />
                  <label for="email">Votre Téléphone</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
                </div>
                <div class="fancy-label name col-12 col-lg-6">
                  <input :class="errors.has('email') ? 'error' : ''" type="text" id="email" name="email" v-validate="'required'" v-model="formContact.dataForm.email" data-vv-validate-on="blur" />
                  <label for="email">Votre Adresse E-mail</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                </div>
                <div class="fancy-label name col-12">
                  <select id="objet" name="objet" class="form-control" v-model="formContact.dataForm.details[1].details[0].value">
                      <option value="Une demande de RDV">Une demande de RDV</option>
                      <option value="Une demande administrative">Une demande administrative</option>
                      <option value="Autre">Autre</option>
                  </select>
                  <label for="objet">Quel est l'objet de votre message ?</label>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-12">
              <div class="row">

                <div class="fancy-label message name col-12 mb-2">
                  <textarea :class="errors.has('message') ? 'error' : ''"  v-validate="'required'" row="5" type="text" id="message" name="message" v-model="formContact.dataForm.details[1].details[1].value" data-vv-validate-on="blur"></textarea>
                  <label for="message">Votre message</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('message')">{{ errors.first('message') }}</span>
                  <input type="hidden" name="nom-praticien" v-model="formContact.dataForm.details[0].details[0].value">

                </div>

                <div class="col-12 col-lg-6">
                    <vue-recaptcha ref="recaptcha" @verify="onVerify" sitekey="6Ldc4TwaAAAAAGQzSYruyBJ-zsoeP89j1uJjdamz">
                    </vue-recaptcha>
                </div>
                <div class="col-12 col-lg-6 mb-4">
                  <button id="button-contact" @click.prevent="submitForm">Envoyer mon message</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <v-style>
      /* Use CustomerVar with example : {{ customizableVar1 }}
      Set Background Image with example :
      background-image:url('\{\{require('@/html/elements/after-page-title-0f555d.svg')}}')
      !important; */
    </v-style>
      <div class="parallax-abstract" v-if="dataPage.route == 'accueil'"></div>
      <div class="parallax-abstract-top" v-else></div>
      <div class="container">
        <div
          class="item noEditMode"
          v-for="(item, index) in layout"
          :key="index"
        >
          <col-widget
            v-if="item.type == 'col'"
            :preview="preview"
            :contenteditable="contenteditable"
            :item="item"
            :itemIndex="index"
          ></col-widget>
          <text-widget
            v-if="item.type == 'text'"
            :preview="preview"
            :contenteditable="contenteditable"
            :item="item"
            :itemIndex="index"
            :themeColors="themeColors"
          ></text-widget>
          <text-area-widget
            v-if="item.type == 'content'"
            :preview="preview"
            :contenteditable="contenteditable"
            :item="item"
            :itemIndex="index"
          ></text-area-widget>
          <image-widget
            v-if="item.type == 'image'"
            :preview="preview"
            :contenteditable="contenteditable"
            :item="item"
            :itemIndex="index"
          ></image-widget>
          <alert-widget
            v-if="item.type == 'alert'"
            :preview="preview"
            :contenteditable="contenteditable"
            :item="item"
            :itemIndex="index"
            :color="item.color"
          >
          </alert-widget>
          <button-widget
            v-if="item.type == 'button'"
            :preview="preview"
            :contenteditable="contenteditable"
            :item="item"
            :itemIndex="index"
          >
          </button-widget>
          <link-widget
            v-if="item.type == 'link'"
            :preview="preview"
            :contenteditable="contenteditable"
            :item="item"
            :itemIndex="index"
          >
          </link-widget>
          <title-widget
            v-if="item.type == 'title'"
            :preview="preview"
            :contenteditable="contenteditable"
            :item="item"
            :itemIndex="index"
          ></title-widget>
          <quote-widget
            v-if="item.type == 'quote'"
            :preview="preview"
            :contenteditable="contenteditable"
            :item="item"
            :itemIndex="index"
          ></quote-widget>
        </div>
      </div>
    
    <div class="bg-footer-page"  v-if="dataPage.route == 'contact' || dataPage.route == 'le-cabinet'" style="background-image:url('./elements/equipe-cbgr.png');background-size: auto 100%; background-position: bottom center; background-repeat: no-repeat; "></div>
-->
</template>
<script>
// FIREBASE
import "firebase/auth";
const firebase = require("firebase");
require("firebase/firestore");
require("firebase/auth");
var db = firebase.firestore();
import { firebaseConfig } from "@/firebase/firebaseConfig";
import { setSubCollection, setSub2Collection } from "@/../script/global";
import axios from "axios";
import dayjs from "dayjs";

import EspHeader from "@/layouts/Header.vue"
// CONFIG
import { themeConfig, irisConfig } from "@/../siteConfig.js";

// SPECIFIC TO PAGEBUILDER
import RowWidget from "../editor/RowWidget";
import ColWidget from "../editor/ColWidget";
import TextWidget from "../editor/TextWidget";
import TextAreaWidget from "../editor/TextAreaWidget";
import ImageWidget from "../editor/ImageWidget";
import AlertWidget from "../editor/alertWidget";
import ButtonWidget from "../editor/ButtonWidget";
import LinkWidget from "../editor/LinkWidget";
import TitleWidget from "../editor/TitleWidget";
import QuoteWidget from "../editor/QuoteWidget";
import { GridLayout, GridItem } from "vue-grid-layout";

// SPECIFIC FOR CONTACT
import VueRecaptcha from "vue-recaptcha";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    lastname: {
      required: "Veuillez saisir votre nom",
    },
    firstname: {
      required: "Veuillez saisir votre prénom",
    },
    phone: {
      required: "Veuillez saisir votre numéro de téléphone",
    },
    email: {
      required: "Veuillez saisir votre adresse email",
    },
    objet: {
      required: "Veuillez saisir l'objet de votre message",
    },
    message: {
      required: "Veuillez saisir votre message",
    },
  },
};
Validator.localize("fr", dict);

export default {
  components: {
    RowWidget,
    ColWidget,
    TextWidget,
    TextAreaWidget,
    ImageWidget,
    AlertWidget,
    ButtonWidget,
    LinkWidget,
    TitleWidget,
    QuoteWidget,
    VueRecaptcha,
    EspHeader,
  },
  name: "page-view",
  props: {
    dataPage: {
      type: Object,
    },
    dataIris: {
      type: Object,
    },
  },
  data() {
    return {
      contenteditable: false,
      preview: true,
      irisConfig: irisConfig,

      // DATA objet pour instancier la collection Leads sur la Dashboard
      formContact:{
        dataForm:{
            lastname: '',
            firstname: '',
            phone: '',
            email: '',
            details:[
                {
                    icon:"",
                    label:"Détails du message",
                    details:[
                        {
                            label:"Prestation souhaitée",
                            value:""
                        },
                        {
                            label:"Date de préférence",
                            value:""
                        },
                        {
                            label:"Message",
                            value:""
                        }
                    ]
                }
            ],
            status:"Non traité",
            addDate:new Date()
        },
        robot: false,
        send:false
      },
      // DATA  pour générer la map OpenStreet
      map: null,
      tileLayer: null,
      mapMarker: [
        {
          id: 0,
          name:
            "<b>VERONIQUE LESOURD</b><br>270A route de Paris<br>76920 Amfreville-La-Mi-Voie",
          type: "marker",
          coords: [49.475604, 1.129772],
        },
      ],
    };
  },
  computed: {
    dataPageInfos: function () {
      if (this.dataPage) {
        return this.dataPage || "";
      } else {
        return "";
      }
    },
    layout: function () {
      if(this.dataPage.route == 'actualites'){
        console.log("this.dataIri", this.$parent.dataIris.articles)
        return "BLOG";
      } else {
        if (this.dataPage.gridLayout.length > 0) {
          return this.dataPage.gridLayout || "";
        } else {
          return "";
        }
      }
    },
    color1: function () {
      if (this.dataIris.customizableVar[0].value) {
        return this.dataIris.customizableVar[0].value;
      } else {
        return "0f555d";
      }
    },
    color2: function () {
      if (this.dataIris.customizableVar[1].value) {
        return this.dataIris.customizableVar[1].value;
      } else {
        return "0f555d";
      }
    },
    customizableVar1: function () {
      if (this.dataIris.customizableVar[0].value) {
        return this.dataIris.customizableVar[0].value;
      } else {
        return "0f555d";
      }
    },
    typePage: function () {
      if (this.dataPageInfos.customizableVar[3].value) {
        return this.dataPageInfos.customizableVar[3].value.value;
      } else {
        return "0";
      }
    },
    urlPictureHeader: function () {
      if (this.dataPage.urlPictureHeader) {
        return this.dataPage.urlPictureHeader;
      } else {
        return ""; // Ajouter  pour définir une image par défaut :  require('@/html/elements/bg-header.jpg')
      }
    },
  },
  mounted() {
    // On verifi si la page est la page contact afin d'initialiser la map
    this.checkPageContact();
  },
  watch: {
    dataPage(newData, old) {
      // On regarde si la route a changée
      //console.log("Ancienne route : ", old, "Nouvelle route : ", newData);
      this.checkPageContact();
    },
  },
  methods: {
    checkPageContact() {
      if (this.dataPage.id == "a8P5GULaqCwITzlJ3fu1") {
        setTimeout(() => {
          // this.initMap();
          // this.initMarkers();
        }, 500);
      } else {
        if (this.map) {
          this.map.remove();
        }
      }
    },

    // Methodes pour la page contact Form et Map
    submitForm() {
      if (this.formContact.robot) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.formContact.send = true;
            this.sendMail()
            setSub2Collection(
              "customers",
              this.irisConfig.customers,
              "sites",
              this.irisConfig.sites,
              "leads",
              this.formContact.dataForm
            );
          } else {
          }
        });
      }
    },
    onVerify: function (response) {
      if (response) this.formContact.robot = true;
    },
    sendMail() {
      // ENVOI DU MAIL
      var data = new FormData();

      data.set("to", 'v.lesourd2@orange.fr');
      data.set("cci", "contact@devinfluence.fr");
     
      data.append("customer", 'VERONIQUE LESOURD');
      data.append("website", 'www.veroniquelesourd.fr');
      data.append("lastname", this.formContact.dataForm.lastname);
      data.append("firstname", this.formContact.dataForm.firstname);
      data.append("phone", this.formContact.dataForm.phone);
      data.append("email", this.formContact.dataForm.email);
       data.append(
        "details",
        JSON.stringify(this.formContact.dataForm.details)
      );
      data.append("date", dayjs().format("DD/MM/YYYY"));
      data.append("hours", dayjs().format("HH"));
      data.append("minutes", dayjs().format("mm"));
      axios({
        method: "post",
        url: "https://app.orisis.fr/api-email.php?request=emailFromWebSiteForm",
        data: data,
      })
        .then(function(reponse) {
          //On traite la suite une fois la réponse obtenue
          //console.log(reponse);
        })
        .catch(function(erreur) {
          //On traite ici les erreurs éventuellement survenues
          console.error(erreur);
        });
    },
    initMarkers() {
      this.mapMarker.forEach((mapMarkerData) => {
        var marker = L.marker(mapMarkerData.coords).addTo(this.map);
        marker.bindPopup(mapMarkerData.name).openPopup();
      });
    },
    initMap() {
      this.map = L.map("mapid").setView([49.475604, 1.129772], 16);
      this.tileLayer = L.tileLayer(
        "https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png",
        {
          maxZoom: 18,
          attribution:
            '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attribution">CARTO</a>',
        }
      );
      this.tileLayer.addTo(this.map);
    },
  },
};
</script>
